import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

const STORAGE_KEY = "monderavello.consent.v1";

function updateConsent(mode) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  if (mode === "granted") {
    gtag("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  } else {
    gtag("consent", "update", {
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
}

export default function CookieBanner() {
  const { t, localePath } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        setVisible(true);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try { localStorage.setItem(STORAGE_KEY, "granted"); } catch (e) {}
    updateConsent("granted");
    setVisible(false);
  };
  const handleReject = () => {
    try { localStorage.setItem(STORAGE_KEY, "denied"); } catch (e) {}
    updateConsent("denied");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-50 bg-white border-t border-[#CBD5E1] shadow-lg"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1 text-sm text-[#334155]">
          <div className="font-semibold text-[#0F2942]">
            {t("cookie_banner.title")}
          </div>
          <p className="mt-1 leading-relaxed">
            {t("cookie_banner.body")}
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2 md:justify-end">
          <Link
            to={localePath("/cookie-policy")}
            data-testid="cookie-banner-manage"
            className="text-sm font-semibold text-[#0F2942] underline underline-offset-4 px-2 py-2"
          >
            {t("cookie_banner.manage")}
          </Link>
          <button
            type="button"
            onClick={handleReject}
            data-testid="cookie-banner-reject"
            className="rounded-md border border-[#0F2942] text-[#0F2942] px-4 py-2 text-sm font-semibold hover:bg-[#F1F5F9]"
          >
            {t("cookie_banner.reject")}
          </button>
          <button
            type="button"
            onClick={handleAccept}
            data-testid="cookie-banner-accept"
            className="rounded-md bg-[#1B4D3E] text-white px-4 py-2 text-sm font-semibold hover:bg-[#123528]"
          >
            {t("cookie_banner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
